export class CommentListConfig {
  limit?: number;
  offset?: number;
  sortBy?: string; // trending or voted
}
